import(/* webpackMode: "eager" */ "/opt/gitlab-runner/builds/syberry-marketing/syberry-com-frontend-v2/src/app/insights/page.tsx")